import React from 'react'
import { Text } from '@node-space/ui-components'

export interface DescriptionProps {
  children: React.ReactNode
  isCentered?: boolean
}

export const Description = ({ children, isCentered }: DescriptionProps) => (
  <Text color="subdued" isCentered={isCentered}>
    {children}
  </Text>
)
